"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListRowItemMark = exports.StyledListRowItem = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledListRowItem = styled_components_1.default.div `
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing(0.5, 1)};
  border-radius: 8px;
  border: 1px solid ${ui_components_1.baseColors.border};
  overflow: hidden;
  // TODO: move it to ui-components
  box-shadow: 0px 2px 4px 0px #00000014;

  .list-row-item-content {
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.palette.grey[700]};
    font-size: 0.75rem;
    line-height: 1.5rem;
  }

  .list-row-item-marks {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(0.5)};
    box-sizing: border-box;
  }

  .list-row-item-origin {
    margin-right: 0.5rem;
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    background-color: ${ui_components_1.baseColors.background000};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing(1)};
    box-sizing: border-box;
    font-size: 0.75rem;
    color:${ui_components_1.baseColors.primaryBlueMed600};
  }
`;
exports.StyledListRowItemMark = styled_components_1.default.div `
  flex-shrink: 0;
  border-radius: 50%;
  box-sizing: border-box;
  width: 1.5rem;
  height: 1.5rem;
  cursor: default;
`;
